import ManageRestaurantTable from "./ManageRestaurantTable";
import { Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';

export default function StoreManagement() {
  const { t } = useTranslation();

  return (
    <>
        <>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            {t('storeManagement.title')}
          </Typography>
          <ManageRestaurantTable/>
        </>
     </>
  )
}
